module.exports = __webpack_public_path__ + "static/media/c2bannerModul2_small.ef95e46f.jpg";